import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { apiCall, saveFile } from './../../components/special/apiCall';
import {useErrorContext} from 'components/messages/ErrorBox';
import InputDate from './../../components/input/InputDate';
import InputCheckBox from './../../components/input/InputCheckBox';
import { usePageLoadingContext } from './../../components/messages/PageLoading';
import { useLocale } from './../../components/special/LanguageProvider';



const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

export const ReturnReport = (props)  => {
    const [returnDate, setReturnDate] = useState(new Date()); 
    const [splitCost, setSplitCost] = useState ({splitCost : false});     
    const setCheckErrorItems = useErrorContext();
    const setIsPageLoading = usePageLoadingContext();
    const { t } = useLocale();


    const isResultOk = (obj) => {
        if ((obj != null) && (obj.error != undefined)){
            setCheckErrorItems([obj]);
            return null;
        }
        return obj;
    }

    const createReport = async () => {
        setIsPageLoading(true);
        console.log("Return date", returnDate, splitCost);
        const data = await apiCall(`${BASE_URL}/features/report/returnaccumulateddata`,{ method: 'post', data: {returnDate: returnDate, splitCost: splitCost}});
        if (isResultOk(data)){
            saveFile(data.fileData, data.fileName, data.contentType);
        }
        setIsPageLoading(false);
    }

    useEffect(() => {
        setSplitCost(false);
      }, []);

  return (
    <div>            
      <h1 className="text-red text-32">{t("Skilgreina skýrsla")}</h1>           
      <div>
        <div className="grid box" id="skref1">
            <div className="col s1of1">
                <div className="grid">
                    <div className="col s1of2">
                        <h3>{t("Dagsetning")}</h3>
                    </div>
                    <div className="col s1of2 text-right">
                        <p>{t("Skref") + " 1 " + t("af") + " 1 "}</p>
                    </div>
                </div>
            </div>
            <div className="col s1of1">
                <div className="grid">
                    <div className="form col s1of2">
                        <p>{t("Taka út skýrslu fyrir þau skil sem hafa verið framkvæmd á ákveðinni dagsetningu.")}</p>                        
                        <InputDate value={returnDate}  onChange={(value) => setReturnDate(value)} />  
                       <InputCheckBox name="splitCostCB" value={splitCost} label={"Fá sundurliðun á kostnaði sem ber VSK"} onChange={(value) => setSplitCost(value)}  />
                                            
                    </div>            
                    <div className="col s1of2 text-right">
                        
                    </div>
                </div>
            </div>
            <div className="col s1of1 text-right">
                <button className="button blue" onClick={createReport}>{t("Útbúa skýrslu í excel")}</button>                        
            </div>
        </div>    
        </div>
    </div>
  );
};
